import React from 'react';
import { connect } from 'react-redux';
import { getComponentVisibility } from '../helpers/toch-helpers';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';

class GenericBanner extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            title,
            subtitle1,
            subtitle2,
            logo,
            description,
            link,
            backgroundImage,
            mobileBackgroundImage,
            componentVisibility,
            ctaClass
        } = this.props.data;

        const isVisible = getComponentVisibility(componentVisibility);
        const lnkClass = 'button button--primary ' + ctaClass;
        const hasLink = (link !== undefined && link !== '');
        const hasBackgroundImage = (backgroundImage !== null && backgroundImage !== '' && backgroundImage !== undefined);
        const hasMobileBackgroundImage = (mobileBackgroundImage !== null && mobileBackgroundImage !== '' && mobileBackgroundImage !== undefined);
        const hasLogo = (logo !== null && logo !== '' && logo !== undefined);

        return (
            isVisible &&
                <>
                <div className="generic-banner__background-wrap">
                    {hasBackgroundImage &&
                    <div className="generic-banner__background">
                        <SitecoreImageField img={backgroundImage} />
                    </div>}
                    {hasMobileBackgroundImage &&
                    <div className="generic-banner__mobile-background">
                        <SitecoreImageField img={mobileBackgroundImage} />
                    </div>}
                </div><div className="generic-banner__wrap">
                    <div className="generic-banner__article">
                        <div className="generic-banner__label">
                            {hasLogo &&
                                <SitecoreImageField img={logo} />}
                            <div className="generic-banner__label--text">
                                <p className="generic-banner__label--strong">{subtitle1}</p>
                                <p className="generic-banner__label--regular">{subtitle2}</p>
                            </div>
                        </div>
                        <div className="generic-banner__content">
                            <h3 className="generic-banner__heading">
                                <span>
                                    {title}
                                </span>
                            </h3>
                            {description}
                        </div>
                        {hasLink &&
                            <div className="generic-banner__button-wrapper">
                                <div>
                                    <SitecoreLinkField className={lnkClass} link={link} />
                                </div>
                            </div>}
                    </div>
                </div></>
        );
    }
}

const GenericBannerContainer = connect(
)(GenericBanner);

export default GenericBannerContainer;
